import styled from "../_snowpack/pkg/@emotion/styled.js";
import React from "../_snowpack/pkg/react.js";
import Stack from "./stack.js";
import {Text, Title} from "./typo.js";
import {CheckGreen} from "./icons.js";
import Button from "./button.js";
import Image from "./image.js";
import {createTemplateStringReplacer} from "../common/utils.js";
import Doc from "./doc.js";
import {media} from "./theme.js";
export default function SuccessPage(props) {
  const {headline, text, button, image, templateData, isPreview, ...rest} = props;
  const [cta] = button || [];
  const templateStringReplacer = createTemplateStringReplacer(templateData, isPreview);
  return /* @__PURE__ */ React.createElement(GridContainer, {
    ...rest
  }, /* @__PURE__ */ React.createElement(SuccessContainer, {
    spacing: "l"
  }, headline && /* @__PURE__ */ React.createElement(TitleWithIcon, null, /* @__PURE__ */ React.createElement(Icon, null), /* @__PURE__ */ React.createElement(Title, {
    level: 4,
    as: "h2"
  }, templateStringReplacer(headline))), text && /* @__PURE__ */ React.createElement(Text, null, typeof text === "string" ? templateStringReplacer(text) : /* @__PURE__ */ React.createElement(Doc, {
    ...text,
    templateStringReplacer
  })), cta && /* @__PURE__ */ React.createElement(ButtonContainer, null, /* @__PURE__ */ React.createElement(Button, {
    href: cta.cta_url
  }, templateStringReplacer(cta.cta_text))), image && /* @__PURE__ */ React.createElement(SuccessIllustrationContainer, {
    ...image
  })));
}
const SuccessContainer = styled(Stack)`
  padding-top: 90px;
  text-align: center;
`;
const Icon = styled(CheckGreen)`
  ${media.mobile} {
    display: none;
  }
`;
const SuccessIllustrationContainer = styled(Image)``;
const TitleWithIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-right: 24px;
  }
`;
const GridContainer = styled.div`
  max-width: 610px;
  margin: 0 auto;
`;
const ButtonContainer = styled.div``;
const OrderNo = styled(Text)`
  font-size: 24px;
  font-weight: bold;
  line-height: calc(1em + 8px);
`;
